import { Pipe, PipeTransform } from '@angular/core';
import { Optional } from '@lib/interfaces';
import { FulfillmentStatus } from '@lib/interfaces/card.interface';

@Pipe({
    name: 'fulfillmentStatus',
    standalone: true,
})
export class FulfillmentStatusPipe implements PipeTransform {
    public transform(value: Optional<FulfillmentStatus>): string {
        switch (value) {
            case FulfillmentStatus.CREATED:
                return 'Created';

            case FulfillmentStatus.ORDERED:
                return 'Ordered';

            case FulfillmentStatus.DELIVERED:
                return 'Delivered';

            case FulfillmentStatus.DISPATCHED:
                return 'Dispatched';

            case FulfillmentStatus.FULFILLED:
                return 'Fulfilled';

            case FulfillmentStatus.REJECTED:
                return 'Rejected';

            default:
                return 'N/A';
        }
    }
}
